import React from 'react'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { KinerjaHarianStatusBadge } from 'app/KinerjaHarian/components/logs/KinerjaHarianStatusBadge'

import type { KinerjaHarianNote } from 'types/kinerja-harian'

interface KinerjaHarianNoteCardProps {
  note: KinerjaHarianNote
}

export function KinerjaHarianNoteCard({ note }: KinerjaHarianNoteCardProps) {
  const hasError = !!note.errorMessage

  if (hasError) {
    return (
      <div className="p-4 pl-12 space-y-3 border rounded-lg border-gray-30">
        <div className="flex items-center gap-2">
          <KinerjaHarianStatusBadge tone="failed">
            Gagal Dikirim ke E-Kinerja
          </KinerjaHarianStatusBadge>
          <Icon color="critical" fontSize="sm">
            warning
          </Icon>
        </div>
        <Text color="subdued" variant="body-sm">
          Alasan: {note.errorMessage}
        </Text>
        <Text>{note.activity}</Text>
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <Icon color="informational" fontSize="sm">
              schedule
            </Icon>
            <Text variant="body">Jam Mulai: {note.startTime}</Text>
          </div>
          <div className="flex items-center gap-2">
            <Icon color="informational" fontSize="sm">
              schedule
            </Icon>
            <Text variant="body">Jam Berakhir: {note.endTime}</Text>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="p-4 border rounded-lg border-gray-30">
      <div className="flex items-start gap-3">
        <span
          aria-hidden="true"
          className="material-symbols-outlined mt-0.5 shrink-0 leading-none"
          style={{
            color: 'var(--color-icon-success)',
            fontSize: '24px',
            height: '24px',
            width: '24px',
          }}
        >
          select_check_box
        </span>
        <div className="space-y-3">
          <Text>{note.activity}</Text>

          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <Icon color="informational" fontSize="sm">
                schedule
              </Icon>
              <Text variant="body">Jam Mulai: {note.startTime}</Text>
            </div>
            <div className="flex items-center gap-2">
              <Icon color="informational" fontSize="sm">
                schedule
              </Icon>
              <Text variant="body">Jam Berakhir: {note.endTime}</Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
